var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionChangeNavigationPoints({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5H6V13H2L7 19L12 13H8V5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18 19H16V11H12L17 5L22 11H18V19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionChangeNavigationPoints);
export default __webpack_public_path__ + "static/media/ic_action_change_navigation_points.03931c79635a40f63cf3ba32a00f4255.svg";
export { ForwardRef as ReactComponent };